// src/components/Input.js
import React from "react";
import { useController } from "react-hook-form";
import clsx from "clsx";
import ErrorDiv from "../ErrorDiv";
import Label from "../Label";

export const Input = ({
  label,
  controlProp,
  tooltip = "",
  placeholder = "",
  onChange = false,
  type = "text",
  numbersOnly = false,
  errorAlignEnd,
  variant = "small",
  labelClass = "",
  customClasses = "",
  className = "",
  isDisabled = false,
  showValidatedIcon = true,
  ...rest
}) => {
  const { field, fieldState } = useController(controlProp);

  const defaultClasses =
    "w-full rounded border-[1.5px] bg-transparent py-3 px-5 text-black outline-none focus:border-blue-500 focus:ring-blue-500 disabled:cursor-default";

  return (
    <div>
      {label && <Label classes={labelClass} label={label} tooltip={tooltip} />}
      <div className="relative mb-3">
        <input
          className={clsx(
            variant,
            fieldState.invalid ? "border-primary bg-light-orange-200" : "",
            className,
            customClasses,
            defaultClasses
          )}
          disabled={isDisabled}
          {...rest}
          type={type}
          placeholder={placeholder}
          {...field}
          onChange={(e) => {
            if (onChange) onChange(e);
            else {
              field.onChange(e);
            }
          }}
          {...(numbersOnly && {
            onKeyDown: (e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            },
          })}
        />
        {fieldState.invalid && (
          <ErrorDiv
            error={fieldState.error?.message}
            errorAlignEnd={errorAlignEnd}
          />
        )}
      </div>
    </div>
  );
};
